import React from 'react';
import { Link } from 'react-router-dom';
import { FaOm, FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaLinkedin, FaGoogle, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-hero text-white pt-20 pb-8 overflow-hidden">
      {/* Gold top border */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-gold" />

      {/* Stars */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <div key={i} className="absolute bg-white rounded-full animate-twinkle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            width: `${Math.random() * 3 + 1}px`,
            height: `${Math.random() * 3 + 1}px`,
          }} />
        ))}
      </div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr] gap-10 mb-12">
          {/* About Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src="/logo.svg" alt="Acharya Arun Logo" className="w-10 h-10 drop-shadow-[0_0_10px_rgba(167,139,250,0.4)]" />
              <div>
                <h3 className="font-heading text-accent-gold text-xl">Acharya Arun</h3>
                <span className="text-[0.7rem] text-accent-amber tracking-[3px] uppercase">Arogya Jyotish</span>
              </div>
            </Link>
            <p className="text-white/65 text-sm leading-relaxed mb-5">
              Your Cosmic Guide to Life. Expert astrologer specializing in health astrology, KP astrology, Vastu, and cosmic healing for a balanced and prosperous life.
            </p>
            <div className="flex gap-3">
              {[
                { href: 'https://share.google/meosnbKBvhMKeJ4uM', icon: <FaGoogle />, label: 'Google' },
                { href: 'https://www.facebook.com/acharya.arun.1/', icon: <FaFacebook />, label: 'Facebook' },
                { href: 'https://www.linkedin.com/in/acharya-arun-89b8928a/', icon: <FaLinkedin />, label: 'LinkedIn' },
                { href: 'https://wa.me/919835040629', icon: <FaWhatsapp />, label: 'WhatsApp' },
              ].map(({ href, icon, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                  className="w-10 h-10 rounded-full border border-accent-gold/25 flex items-center justify-center text-accent-gold text-base transition-all duration-300 bg-[rgba(167,139,250,0.05)] hover:bg-accent-gold hover:text-primary-deep hover:-translate-y-1 hover:shadow-gold-sm hover:border-accent-gold">
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-accent-gold text-lg mb-5 pb-2.5 relative footer-heading">Quick Links</h4>
            {[['/', 'Home'], ['/services', 'Services'], ['/about', 'About Us'], ['/contact', 'Contact Us']].map(([to, label]) => (
              <Link key={to} to={to} className="block text-white/65 text-sm mb-3 transition-all duration-300 hover:text-accent-gold hover:pl-3.5 footer-link">
                {label}
              </Link>
            ))}
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-accent-gold text-lg mb-5 pb-2.5 relative footer-heading">Our Services</h4>
            {['Career Advice', 'Medical Astrology', 'Gem Suggestion', 'Marriage & Progeny', 'Vastu Consultation'].map((s) => (
              <Link key={s} to="/services" className="block text-white/65 text-sm mb-3 transition-all duration-300 hover:text-accent-gold hover:pl-3.5 footer-link">
                {s}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-accent-gold text-lg mb-5 pb-2.5 relative footer-heading">Get In Touch</h4>
            <a href="tel:+918084768303" className="flex items-center gap-2.5 text-white/70 text-sm mb-4 transition-colors hover:text-accent-gold">
              <FaPhone /> +91 80847 68303
            </a>
            <a href="mailto:acharyaarunastrology@gmail.com" className="flex items-center gap-2.5 text-white/70 text-sm mb-4 transition-colors hover:text-accent-gold">
              <FaEnvelope /> acharyaarunastrology@gmail.com
            </a>
            <p className="flex items-start gap-2.5 text-white/70 text-sm mb-4">
              <FaMapMarkerAlt className="mt-1 flex-shrink-0" /> Flat No 402, 4th Floor, Nand Maheshwari Apartment, Behind Harihar Chamber, Gorakhnath Lane, Kidwaipuri, Patna-800001, Bihar
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-4 mb-5">
            <span className="h-px w-[150px]" style={{ background: 'linear-gradient(90deg, transparent, rgba(167,139,250,0.5), transparent)' }} />
            <img src="/logo.svg" alt="Acharya Arun" className="w-7 h-7 drop-shadow-[0_0_8px_rgba(167,139,250,0.3)] animate-breathe" />
            <span className="h-px w-[150px]" style={{ background: 'linear-gradient(90deg, transparent, rgba(167,139,250,0.5), transparent)' }} />
          </div>
          <p className="text-white/50 text-sm">&copy; {new Date().getFullYear()} Acharya Arun Arogya Jyotish. All Rights Reserved.</p>
          <p className="text-white/35 text-xs mt-2">Powered by <a href="https://styekdigital.com/" target="_blank" rel="noopener noreferrer" className="text-accent-gold/70 hover:text-accent-gold transition-colors duration-200">Styek Digital</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
